"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MedibankConfig = void 0;
var _medibankThemeContext = require("./medibankThemeContext");
var _medibankStepsDefinitions = require("./quoteTools/medibankStepsDefinitions");
var _medibankSummary = require("./quoteTools/medibankSummary");
var _medibankCustomRouteDefinitions = require("./quoteTools/medibankCustomRouteDefinitions");
var _medibankQuoteToolContext = require("./quoteTools/medibankQuoteToolContext");
var _medibankSuccess = require("./quoteTools/medibankSuccess");
var _defaultIcons = require("../../defaults/productTable/defaultIcons");
var _defaultOptionalInclusions = require("../../defaults/productTable/staff/defaultOptionalInclusions");
var _defaultStaffInstructions = require("../../defaults/productTable/staff/defaultStaffInstructions");
var _defaultAuthorisedPersonDisplaySettings = require("../../defaults/quoteTools/defaultAuthorisedPersonDisplaySettings");
var _defaultRegularVetDisplaySettings = require("../../defaults/quoteTools/defaultRegularVetDisplaySettings");
var _defaultSummary = require("../../defaults/quoteTools/defaultSummary");
var _defaultStaffContext = require("../../defaults/quoteTools/staff/defaultStaffContext");
var _defaultPayment = require("../../defaults/quoteTools/defaultPayment");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var quoteTools = {
  themeOverrides: _medibankQuoteToolContext.MedibankQuoteToolContext,
  steps: {
    StepDefinitions: _medibankStepsDefinitions.MedibankStepDefinitions,
    basicOwnerDetails: _medibankQuoteToolContext.medibankBasicOwnerDetails,
    fullOwnerDetails: _medibankQuoteToolContext.medibankFullOwnerDetails,
    aboutPet: _medibankQuoteToolContext.MedibankAboutPet,
    coverDisplayOptions: _medibankQuoteToolContext.MedibankCoverDisplayOptions,
    summary: _medibankSummary.medibankSummary,
    success: _medibankSuccess.MedibankSuccess,
    payment: _defaultPayment.defaultPayment,
    bannerStyle: 'bullets',
    showCompletedStepBannerOnPage: 'step6'
  },
  widgets: {
    authorisedPersonDisplaySettings: _defaultAuthorisedPersonDisplaySettings.defaultAuthorisedPersonDisplaySettings,
    regularVetDisplaySettings: _objectSpread(_objectSpread({}, _defaultRegularVetDisplaySettings.defaultRegularVetDisplaySettings), {}, {
      regularVetInput: _objectSpread(_objectSpread({}, _defaultRegularVetDisplaySettings.defaultRegularVetDisplaySettings.regularVetInput), {}, {
        labelTooltip: 'If you have a regular vet but their clinic name does not appear in the list, select \'Unknown\''
      })
    })
  },
  customRouteDefinitions: _medibankCustomRouteDefinitions.medibankCustomRouteDefinition,
  staffModeContext: _defaultStaffContext.DefaultStaffModeContext,
  productTable: {
    optionalInclusions: _defaultOptionalInclusions.DefaultOptionalInclusions,
    staffInstructions: _defaultStaffInstructions.DefaultStaffInstructions,
    icons: _defaultIcons.defaultIcons
  },
  middlewareApiKeys: {
    "public": {
      sit: {
        applicationId: '751158A8-CEBA-47E2-916E-75F63E69B5D3',
        apiKey: '6S6750185567C543FEA',
        expiry: 3600
      },
      uat: {
        applicationId: '751158A8-CEBA-47E2-916E-75F63E69B5D3',
        apiKey: '6S6750185567C543FEA',
        expiry: 3600
      },
      preprod: {
        applicationId: '3ED572EE-C71C-4E44-830E-70E5D3B9EE4E',
        apiKey: '0F4B252447DA430688',
        expiry: 3600
      },
      prod: {
        applicationId: 'C973457A-C3F7-4C19-92B0-DA433CFA0494',
        apiKey: '0DE3D7C064214AF0B6',
        expiry: 3600
      }
    },
    staff: {
      sit: {
        applicationId: '535993DB-4760-463B-B0C5-784D1C717E09',
        apiKey: '6K2441D29A3228492E9',
        expiry: 3600
      },
      uat: {
        applicationId: '535993DB-4760-463B-B0C5-784D1C717E09',
        apiKey: '6K2441D29A3228492E9',
        expiry: 3600
      },
      preprod: {
        applicationId: '76B868F9-A220-4F77-AFD4-6933DBC567AB',
        apiKey: 'B6649097E9AE42E084',
        expiry: 3600
      },
      prod: {
        applicationId: 'A9D17B68-B872-41D2-A639-F320D381349B',
        apiKey: '3D6B80B6978C462893',
        expiry: 3600
      }
    }
  },
  recaptchaSiteKey: '6LetOPskAAAAAKerkAU1MHWND52nX2rG_FnrwcTH',
  recaptchaSecretKey: '6LetOPskAAAAAGvUc7Y_dbUZch-jZad5HyO7RBUY',
  recaptchaSiteKeyProd: '6LcuPfskAAAAAD80pRF9K0Mu5WOc6Er0ZBIwDH2W',
  recaptchaSecretKeyProd: '6LcuPfskAAAAAEoWhTpi0C2vHf4J8WAaRTGhk5mr'
};
var MedibankConfig = exports.MedibankConfig = {
  theme: _objectSpread(_objectSpread({}, _medibankThemeContext.MedibankThemeContext), {}, {
    brand: _objectSpread(_objectSpread({}, _medibankThemeContext.MedibankThemeContext.brand), {}, {
      brokers: {
        mplvff: {
          theme: _objectSpread(_objectSpread({}, _medibankThemeContext.MedibankThemeContext), {}, {
            brand: _objectSpread(_objectSpread({}, _medibankThemeContext.MedibankThemeContext.brand), {}, {
              broker: 'MPLVFF',
              key: 'mplvff',
              styleSheet: 'medibank'
            })
          }),
          quoteTools: quoteTools
        }
      }
    })
  }),
  quoteTools: quoteTools
};